
export const removeTrailingSlash = (path: string) => {
    if (path !== '/') {
        return path.replace(/\/$/, '');
    }
    return path;
};